import React, { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import JobSelection from "./JobSelection";
import GroundworksTakeoffConfig from "./groundworks/GroundworksTakeoffConfig";
import RoadsSewersTakeoffConfig from "./roads-sewers/RoadsSewersTakeoffConfig";
import type { JobType } from "./types";

const TakeoffConfiguration: React.FC = () => {
  const [selectedJobType, setSelectedJobType] = useState<JobType | null>(null);

  if (!selectedJobType) {
    return (
      <MainLayout canProceed={false} showFooter={false}>
        <JobSelection onSelect={setSelectedJobType} />
      </MainLayout>
    );
  }

  if (selectedJobType === "groundworks") {
    return <GroundworksTakeoffConfig onChangeJobType={() => setSelectedJobType(null)} />;
  }

  return <RoadsSewersTakeoffConfig onChangeJobType={() => setSelectedJobType(null)} />;
};

export default TakeoffConfiguration;
